// src/pages/KeyFactStatement.js

import React from 'react';
import './key-fact-statement.css';
import './terms-conditions.css';

const keyFacts = [
  ["Loan Amount", "Total Amount Sanctioned"],
  ["Total Interest Charge During The Entire Tenure Of The Loan", "Upto 1% Per Day"],
  ["Processing Fee (Including GST)", "8-15% Of The Loan Amount"],
  ["Insurance Charges, If Any (In Rupees)", "Applicable If Required"],
  ["Foreclosure Charges", "Upto 5% of Principal Outstanding + GST (Excluding Payday Loan)"],
  ["Net Disbursed Amount", "(I)-(III) (In Rupees)"],
  ["Total Amount To Be Paid By The Borrower", "Sum Of (I), (II) And (III) (In Rupees)"],
  ["Annual Percentage Rate - Effective Annualized Interest Rate (In Percentage) (Considering The ROI Of 1% Per Day)", "16% to 365%"],
  ["Tenure Of The Loan (Days)", "No. Of Days The Loan Is Availed"],
  ["Repayment Frequency By The Borrower", "One to Three Time Only"],
  ["Number Of Installments Of Repayment", "1 to 3"],
  ["Amount Of Each Installment Of Repayment (In Rupees)", "(VII) + Applicable Interest"],
  ["__SECTION__", "Details About Contingent Charges"], // merged row
  ["Rate Of Annualized Penal Charges In Case Of Delayed Payments (If Any)", "Upto 3% Per Month"],
  ["__SECTION__", "Other Disclosures"], // merged row
  ["Cooling Off/Look-Up Period During Which Borrower Shall Not Be Charged Any Penalty On Prepayment Of Loan", "3 Day"],
  ["Name, Designation, Address And Phone Number Of Grievance Redressal Officer Designated Specifically To Deal With FinTech/ Digital Lending Related Complaints/ Issues", 
   "Jitender Kumar, A-29, MONGOL PURI, INDUSTRIAL AREA, PHASE - II, South West Delhi, Delhi, 110034. Contact: 9910739751."]
];

const KeyFactStatement = () => {
  let srNo = 1;

  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Interest Rate Policy</h1>
      </header>

      <section className="tc-content mb-3">

        <div className="table-responsive">
          <table className="kfs-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Parameter</th>
                <th>Details (Illustrative Purposes Only)</th>
              </tr>
            </thead>
            <tbody>
              {keyFacts.map(([param, detail], index) => {
                if (param === "__SECTION__") {
                  return (
                    <tr key={`section-${index}`}>
                      <td colSpan="3" className="section-heading text-center fw-bold">{detail}</td>
                    </tr>
                  );
                }

                return (
                  <tr key={index}>
                    <td><strong>({srNo++})</strong></td>
                    <td>{param}</td>
                    <td>{detail}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default KeyFactStatement;
